import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { PermissionContext } from './PermissionContext';
import { isNullOrUndefined } from '../utils/functionsUtils';

const PrivateRoute = ({
  component: Component,
  when,
  whenMultiple = [],
  ...props
}) => {
  const { hasPermission, permissions } = useContext(PermissionContext);

  const userLogged = !!localStorage.getItem("token");

  if (!userLogged) return (<Redirect to="/" />);

  const requiresPermission = !isNullOrUndefined(when) || whenMultiple.length > 0;

  // ponytail: on refresh the session restore (validate-token) is async and
  // permissions land after this first render. Wait instead of bouncing to
  // /welcome. If the token is invalid, REFRESH_TOKEN_ERROR clears it and
  // userLogged flips to the login redirect above — so this never hangs.
  if (requiresPermission && permissions.length === 0) return null;

  let isAllowed = true;

  if (!isNullOrUndefined(when)) isAllowed = hasPermission(when);

  if (whenMultiple.length > 0) isAllowed = whenMultiple.every((perm) => hasPermission(perm));

  if (!isAllowed) return (<Redirect to="/welcome" />);

  return (
    <Route {...props}
      render={(props) => <Component {...props} />}
    />)

};

export default PrivateRoute;
